// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reviews {
  background-color: rgba(144, 110, 103, 1);
  width: 100%;
  padding: 200px 0 200px 0;
  display: flex;
  flex-direction: column;
  margin: 0 auto 0 auto;
}

.reviews__all-container {
  max-width: 1386px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.reviews__header-container {
  display: flex;
  margin: 0 0 86px 0;
}

.reviews__header {
  font-size: 60px;
  font-weight: 500;
  line-height: 50px;
  font-family: 'Playfair Display';
  margin: 0 125px 0 0;
  padding: 0;
}

.reviews__header-line {
  width: 450px;
  height: 1px;
  background-color: white;
  margin: 34px 0 0 0;
}

@media screen and (max-width: 1439px) {
  .reviews {
    padding: 100px 0 100px 0;
  }

  .reviews__all-container {
    max-width: 984px;
  }

  .reviews__header-container {
    margin: 0 0 36px 0;
  }

  .reviews__header {
    font-size: 45px;
    line-height: 55px;
    margin: 0 18px 0 0;
  }

  .reviews__header-line {
    width: 387px;
  }
}

@media screen and (max-width: 1023px) {
  .reviews {
    padding: 75px 0 75px 0;
  }

  .reviews__all-container {
    max-width: 708px;
  }

  .reviews__header {
    font-size: 35px;
    line-height: 45px;
    margin: 0 18px 0 0;
  }

  .reviews__header-line {
    margin: 25px 0 0 0;
  }
}

@media screen and (max-width: 763px) {
  .reviews {
    padding: 90px 0 90px 0;
  }

  .reviews__all-container {
    max-width: 320px;
  }

  .reviews__header-container {
    margin: 0 0 65px 0;
  }  

  .reviews__header {
    font-size: 36px;
    font-weight: 600;
    line-height: 34px;
    margin: 0 27px 0 0;
  }

  .reviews__header-line {
    width: 150px;
    margin: 23px 0 0 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reviews/Reviews.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":[".reviews {\r\n  background-color: rgba(144, 110, 103, 1);\r\n  width: 100%;\r\n  padding: 200px 0 200px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0 auto 0 auto;\r\n}\r\n\r\n.reviews__all-container {\r\n  max-width: 1386px;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0 auto;\r\n}\r\n\r\n.reviews__header-container {\r\n  display: flex;\r\n  margin: 0 0 86px 0;\r\n}\r\n\r\n.reviews__header {\r\n  font-size: 60px;\r\n  font-weight: 500;\r\n  line-height: 50px;\r\n  font-family: 'Playfair Display';\r\n  margin: 0 125px 0 0;\r\n  padding: 0;\r\n}\r\n\r\n.reviews__header-line {\r\n  width: 450px;\r\n  height: 1px;\r\n  background-color: white;\r\n  margin: 34px 0 0 0;\r\n}\r\n\r\n@media screen and (max-width: 1439px) {\r\n  .reviews {\r\n    padding: 100px 0 100px 0;\r\n  }\r\n\r\n  .reviews__all-container {\r\n    max-width: 984px;\r\n  }\r\n\r\n  .reviews__header-container {\r\n    margin: 0 0 36px 0;\r\n  }\r\n\r\n  .reviews__header {\r\n    font-size: 45px;\r\n    line-height: 55px;\r\n    margin: 0 18px 0 0;\r\n  }\r\n\r\n  .reviews__header-line {\r\n    width: 387px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1023px) {\r\n  .reviews {\r\n    padding: 75px 0 75px 0;\r\n  }\r\n\r\n  .reviews__all-container {\r\n    max-width: 708px;\r\n  }\r\n\r\n  .reviews__header {\r\n    font-size: 35px;\r\n    line-height: 45px;\r\n    margin: 0 18px 0 0;\r\n  }\r\n\r\n  .reviews__header-line {\r\n    margin: 25px 0 0 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 763px) {\r\n  .reviews {\r\n    padding: 90px 0 90px 0;\r\n  }\r\n\r\n  .reviews__all-container {\r\n    max-width: 320px;\r\n  }\r\n\r\n  .reviews__header-container {\r\n    margin: 0 0 65px 0;\r\n  }  \r\n\r\n  .reviews__header {\r\n    font-size: 36px;\r\n    font-weight: 600;\r\n    line-height: 34px;\r\n    margin: 0 27px 0 0;\r\n  }\r\n\r\n  .reviews__header-line {\r\n    width: 150px;\r\n    margin: 23px 0 0 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
